module.exports = __webpack_public_path__ + "static/media/image10.05824110.png";